@use "variables" as *;

.albumName {
  font-size: $fontSize-xxl;
  padding: $spacing-xs calc(#{$spacing-s} + #{$spacing-m}) $spacing-xxs !important;
}

.artistName {
  font-size: $fontSize-s;
  padding: $spacing-xs calc(#{$spacing-s} + #{$spacing-m}) $spacing-s !important;
}

.shareButton {
  border-radius: 0 !important;
  height: 100%;
}

.shareIcon {
  width: 22px !important;
  height: 22px !important;
}

.loadingIndicator {
  height: 24px !important;
  width: 24px !important;
  margin-right: $spacing-m;
}

.loadingDiv {
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
